import { render, staticRenderFns } from "./PagesHome.vue?vue&type=template&id=525f4cc2&scoped=true&"
import script from "./PagesHome.vue?vue&type=script&lang=js&"
export * from "./PagesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f4cc2",
  null
  
)

export default component.exports